var getScrollPos = () => {
  var doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
};
var getElementTop = element => {
  if (!element) {
    return 0;
  }
  var bodyRect = document.body.getBoundingClientRect();
  var elemRect = element.getBoundingClientRect();
  return elemRect.top - bodyRect.top;
};
var getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
export { getScrollPos, getElementTop, getViewportHeight };